import { ServiceTokens } from "$src/domain/ServiceTokens";
import { PagedResult } from "$src/domain/core/PagedResult";
import { type CustomerSummary } from "$src/domain/customers/CustomerSummary";
import type { ICustomerRepository } from "$src/domain/customers/ICustomerRepository";
import { inject, injectable } from "tsyringe";

@injectable()
export class GetCustomersByRecentProjects {
    
    constructor(@inject(ServiceTokens.CustomerRepository) private customerRepository: ICustomerRepository) {}

    async execute(groupStoreId: number, pageNumber: number, search: string): Promise<PagedResult<CustomerSummary>> {
        return this.customerRepository.getCustomersByRecentProjects(groupStoreId.toString(), search, pageNumber, 30);
    }
}


export const GetCustomersByRecentProjectsToken = Symbol('GetCustomersByRecentProjectsToken');    

